import {useState, ReactNode} from 'react';

import {CheckoutIssuingContext} from './CheckoutIssuingContext';

export function CheckoutIssuingProvider(props: {children: ReactNode}) {
  const [isCheckoutIssuing, setIsCheckoutIssuing] = useState(false);

  return (
    <CheckoutIssuingContext.Provider value={{isCheckoutIssuing, setIsCheckoutIssuing}}>
      {props.children}
    </CheckoutIssuingContext.Provider>
  );
}
